import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
function RevealBlock({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useScrollReveal<HTMLDivElement>();
  return <div ref={ref} className={`opacity-0 translate-y-10 transition-all duration-700 ease-out ${className}`} data-id="element-271">
      {children}
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-verde-menta py-20 px-5" data-id="element-272">
      <div className="max-w-[760px] mx-auto" data-id="element-273">
        <RevealBlock data-id="element-274">
          <p className="text-[0.8rem] font-bold tracking-[2px] uppercase text-verde-bosque mb-3 flex items-center gap-2" data-id="element-275">
            <span className="w-6 h-0.5 bg-verde-bosque rounded-sm" data-id="element-276" />
            Primeras Validaciones
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-277">
          <h2 className="font-display font-bold text-negro-carbon leading-[1.25] mb-6" style={{
          fontSize: 'clamp(1.6rem, 4vw, 2.4rem)'
        }} data-id="element-278">
            Mujeres que{' '}
            <span className="text-verde-bosque" data-id="element-279">probaron el protocolo</span>
            <br data-id="element-280" />y cambiaron su metabolismo.
          </h2>
        </RevealBlock>

        <RevealBlock data-id="element-281">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-10" data-id="element-282">
            <TestimonialCard initial="C" name="Carmen R." info="54 años · Ciudad de México" text="A los 52 años pensaba que mi cintura no volvería nunca. En solo 4 días con este protocolo, la inflamación de mi abdomen bajó visiblemente. Volví a ponerme unos pantalones que tenía guardados hace 2 años." data-id="element-283" />
            <TestimonialCard initial="M" name="María L." info="49 años · Bogotá, Colombia" text="Lo del café en ayunas me cambió la vida. Llevaba años haciéndolo y nunca imaginé que eso estaba bloqueando mi metabolismo. En 48 horas ya sentí la diferencia en mi energía y los antojos de la noche desaparecieron." data-id="element-284" />
            <TestimonialCard initial="P" name="Patricia V." info="57 años · Miami, Florida" text="Pensé que era otra guía más de 'come menos'. Me sorprendió que no me pidiera eliminar nada. Solo cambiar el orden. Llevo 7 días y mi ropa de cintura ya me queda diferente. Sin pasar hambre." data-id="element-285" />
          </div>
        </RevealBlock>
      </div>
    </section>;
}
function TestimonialCard({
  initial,
  name,
  info,
  text
}: {
  initial: string;
  name: string;
  info: string;
  text: string;
}) {
  return <div className="bg-white rounded-card py-7 px-6 shadow-suave relative transition-all duration-300 hover:-translate-y-1 hover:shadow-fuerte" data-id="element-286">
      {/* Decorative quote mark */}
      <span className="absolute top-4 right-6 font-display text-[5rem] text-verde-menta leading-none font-black select-none pointer-events-none" data-id="element-287">
        "
      </span>

      <div className="text-oro text-[0.9rem] tracking-[2px] mb-3.5" data-id="element-288">★★★★★</div>

      <p className="text-[0.95rem] text-gray-700 leading-[1.75] mb-5 italic relative z-10" data-id="element-289">
        "{text}"
      </p>

      <div className="flex items-center gap-3" data-id="element-290">
        <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-base flex-shrink-0" style={{
        background: 'linear-gradient(135deg, #2B4A42, #C9A84C)'
      }} data-id="element-291">
          {initial}
        </div>
        <div data-id="element-292">
          <div className="font-bold text-negro-carbon text-[0.9rem]" data-id="element-293">
            {name}
          </div>
          <div className="text-[0.78rem] text-gris-suave" data-id="element-294">{info}</div>
        </div>
      </div>
    </div>;
}